const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  deleteAddressButton: 'button[data-confirm-message]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container
      ? {
          container,
          addressContainer: container.querySelector(selectors.addressContainer),
          deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
          countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
        }
      : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  };
}

(function () {
  const style = document.createElement('style');
  style.textContent = `
    .password-field-wrapper {
      position: relative;
    }
    .password-field-wrapper .form-control {
      padding-right: 2.75rem;
    }
    .password-toggle-btn {
      position: absolute;
      top: 50%;
      right: 0.75rem;
      transform: translateY(-50%);
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      color: inherit;
      opacity: 0.6;
      line-height: 0;
      transition: opacity 0.2s;
    }
    .password-toggle-btn:hover,
    .password-toggle-btn:focus-visible {
      opacity: 1;
      outline: none;
    }
  `;
  document.head.appendChild(style);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-password-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const inputId = btn.getAttribute('aria-controls');
        const input = document.getElementById(inputId);
        if (!input) return;

        const isVisible = input.type === 'text';
        input.type = isVisible ? 'password' : 'text';
        btn.setAttribute('aria-label', isVisible ? 'Show password' : 'Hide password');
        btn.querySelector('.icon-eye').style.display = isVisible ? '' : 'none';
        btn.querySelector('.icon-eye-slash').style.display = isVisible ? 'none' : '';
      });
    });
  });
})();

(function(){
  function getOverlay(){
    return document.querySelector('site-overlay');
  }
  function lockBody(){ document.body.classList.add('scroll-fixed'); }
  function unlockBody(){ document.body.classList.remove('scroll-fixed'); }

  function openAccountPopover(trigger, popover){
    if(!trigger || !popover) return;
    trigger.setAttribute('aria-expanded', 'true');
    popover.classList.add('is-open');
    getOverlay()?.classList.add('overlay-body');
    lockBody();
  }
  function closeAccountPopover(trigger, popover){
    if(!trigger || !popover) return;
    trigger.setAttribute('aria-expanded', 'false');
    popover.classList.remove('is-open');
    getOverlay()?.classList.remove('overlay-body');
    unlockBody();
  }

  document.addEventListener('DOMContentLoaded', function(){
    const sidebar = document.querySelector('[data-account-sidebar]');
    if(!sidebar) return;
    const trigger = sidebar.querySelector('[data-account-sidebar-trigger]');
    const popover = sidebar.querySelector('[data-account-sidebar-popover]');
    const closeBtn = sidebar.querySelector('[data-account-sidebar-close]');
    const overlay = getOverlay();

    if(!trigger || !popover) return;

    document.addEventListener('click', (e) => {
      if(popover.classList.contains('is-open') && !sidebar.contains(e.target)){
        closeAccountPopover(trigger, popover);
      }
    });
    overlay?.addEventListener('click', () => closeAccountPopover(trigger, popover));

    trigger.addEventListener('click', function(e){
      e.preventDefault();
      if(popover.classList.contains('is-open')){
        closeAccountPopover(trigger, popover);
      } else {
        openAccountPopover(trigger, popover);
      }
    });

    if(closeBtn){
      closeBtn.addEventListener('click', function(e){
        e.preventDefault();
        closeAccountPopover(trigger, popover);
      });
    }
  });
})();